import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/gallery';

export interface GallerySettings {
    'content_gallery_title': string;
    'content_gallery_description': string;
    'content_gallery_images': string[];
}

export interface GetGallerySuccessResponse {
    data: GallerySettings;
    success: boolean;
    message: string;
}

export const useGetGallery = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [gallery, setGallery] = useState<GallerySettings | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar gallery') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetGallerySuccessResponse = await response.json();

            setGallery(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar gallery');
        } finally {
            setLoading(false);
        }
    };

    return { gallery, request, loading, error };
};
